export default __webpack_public_path__ + "6d906e3c37181af27734738b8ccaca19.svg";